import { RentalOrBuy } from "./RentalOrBuy";

const RentalNote = () => {
  return (
    <ul className="dialog-note">
      <li className="dialog-note-item">
        未成年者の場合、必ず保護者の同意を得た上で
        <RentalOrBuy />
        してください。
      </li>
      <li className="dialog-note-item">
        サイト内に表示する方法によるお支払方法の手続きが完了し次第、すぐにご利用いただけます。
      </li>
      <li className="dialog-note-item">
        <RentalOrBuy />
        後のキャンセル/返金はできません。
      </li>
    </ul>
  );
};

export default RentalNote;
